/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'pip-common.overlay',
    'pip-cart'
],
function(
    $,
    Mustache,
    pip,
    pipEvents,
    pipOverlay,
    pipCart
) {

    var view = {
        selectors: {
            paypalCheckoutBtn: '#paypal_checkout_btn'
        },
        templates: {
            paypalOverlay:$('#paypal_overlay').html() 
        }
    }
    var isStoreInventoryErrorState;
    var FULFILLMENT_TYPE = {
        PICKUP: '',
        SHIP: 'ShipToHome'
    };

    var fulfillmentTransformationMap = {
        BOPIS: 'BOPIS',
        BOSS: 'ShipToStore'
    };

    function isPaypalEligible() {
        if (pip.features && !pip.features.payPalPaymentOptionEnabled) return false;
        var isEligible = true;
        if(pip.pipCheckoutOptions && !pip.pipCheckoutOptions.isPayPalAvailable) {
            isEligible = false;
        }
        if(pip.customer.getNumberItemsInCart() > 0) {
            isEligible = false;
        }
        if(pip.customer.isLoggedIn()) {
            isEligible = false;
        }
        return isEligible;
    }

    function updateFulfillmentType() {
        if (pip.fulfillment.store) {
            FULFILLMENT_TYPE.PICKUP = fulfillmentTransformationMap[pip.fulfillment.store.fulfillmentType]
        }
    }

    function shouldShowOverlay() {
        return (isStoreFulfillable() && !isStoreInventoryErrorState) && isShippingFulfillable();
    }

    function isStoreFulfillable() {
        return (pip.fulfillment.store
        && ((pip.fulfillment.store.buyOnlinePickUpInStore && !pip.fulfillment.store.buyOnlinePickUpInStore.isRestricted)
        || (pip.fulfillment.store.buyOnlineShipToStore && !pip.fulfillment.store.buyOnlineShipToStore.isRestricted)));
    }

    function isShippingFulfillable() {
        return (pip.fulfillment.shipping && pip.fulfillment.shipping.shipToHome);
    }

    function determineFulfillmentType() {
        var fulfillmentMethod;
        if(pip.fulfillment.store) {
            fulfillmentMethod = FULFILLMENT_TYPE.PICKUP;
        }
        if(pip.fulfillment.shipping && pip.fulfillment.shipping.shipToHome) {
            fulfillmentMethod = FULFILLMENT_TYPE.SHIP;
        }
        if(isStoreInventoryErrorState) {
            fulfillmentMethod = FULFILLMENT_TYPE.SHIP;
        }
        return fulfillmentMethod;
    }

    function initEventListeners() {
        $(document).off('click.paypal');
        $(document).on('click.paypal touchend.paypal', view.selectors.paypalCheckoutBtn, function(e) {
            e.preventDefault();
            e.stopPropagation();

            if($(this).parent().hasClass('pseudo-button--disabled')) return;

            if(shouldShowOverlay()) {
                var overlay = pipOverlay.create('paypalOverlay', view.templates.paypalOverlay);
                overlay.show();
                initOverlayListeners();
            } else {
                var fulfillmentType = determineFulfillmentType();
                pipCart.paypalAddToCart(fulfillmentType);
            }
        });

        pipEvents.customer.customerQuantityErrorStateChanged.off('.paypalQuantityError');
        pipEvents.customer.customerQuantityErrorStateChanged.on('.paypalQuantityError', function(evtType, state) {
            isStoreInventoryErrorState = state.isErrorState;
            togglePaypalQuantityError(state.isErrorState)
        });

        pipEvents.dualPath.dualPathOptInStateChanged.off('.paypal-dualPathStateChanged');
        pipEvents.dualPath.dualPathOptInStateChanged.on('.paypal-dualPathStateChanged', function() {
            $(view.selectors.paypalCheckoutBtn).toggle(!pip.customer.dualPath.isOptedIn);
        });

        pipEvents.customer.customerSubscriptionStateChanged.off('.paypal-SubscribeAndSaveStateChanged');
        pipEvents.customer.customerSubscriptionStateChanged.on('.paypal-SubscribeAndSaveStateChanged', function() {
            $(view.selectors.paypalCheckoutBtn).toggle(!pip.customer.subscriptions.isOptedIn);
        });
    }

    function initOverlayListeners() {
        $(document).off('click.paypalOverlay');
        $(document).on('click.paypalOverlay', '#paypal-overlay__pickItUp, #paypal-overlay__shipItATC', function() {
            var fulfillmentType = $(this).attr('data-fulfillment-type') === 'pickup' ? FULFILLMENT_TYPE.PICKUP : FULFILLMENT_TYPE.SHIP;
            pipCart.paypalAddToCart(fulfillmentType);
        });
    }

    function togglePaypalQuantityError(isErrorState) {
        var paypalButton = $('.buybelt__sub-buybelt__paypal');
        if(isErrorState && isStoreFulfillable() && !isShippingFulfillable()) {
            paypalButton.removeClass('pseudo-button').addClass('pseudo-button--disabled');
            paypalButton.find('.pip-icons').removeClass('paypal').addClass('paypal--disabled')
        } else {
            paypalButton.removeClass('pseudo-button--disabled').addClass('pseudo-button');
            paypalButton.find('.pip-icons').removeClass('paypal--disabled').addClass('paypal')
        }
    }

    return {
        init: function init() {
            if(isPaypalEligible()) {
                initEventListeners();
                updateFulfillmentType();
            }
        },
        isPaypalEligible: isPaypalEligible,
        shouldShowOverlay: shouldShowOverlay,
        determineFulfillmentType: determineFulfillmentType
    }
});

}.call(window));